
import { BrowserRouter } from 'react-router-dom';
import { useTheme } from "./context/ThemeContext";

import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import AppRoutes from './routes/AppRoutes';

import './App.css';

function App() {
  const { theme } = useTheme();
  return ( 
    <BrowserRouter>
      <div className={`App ${theme}`}>
        <Navbar />
        <div className="main-container">
          <Sidebar />
          <main className="main-content">
            <AppRoutes />  {/* other routers are called from here  */}
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
